<script lang="ts">
  import OnlineOnlyLabel from './productTile/components/OnlineOnlyLabel.svelte';
  import ProductTileRatingReviews from './productTile/components/ProductTileRatingReviews.svelte';

  export let data: any = {};
  export let productStore: any = null;
  export let opt: any = {};
  export let isPLP = false;

  $: showSection = opt?.showRatingReview || data?.isOnlineOnly;

  $: hasRating = !!data?.rating;

  $: hasPrice = opt?.showPrice && data?.price && typeof data.price === 'object' && Object.keys(data.price).length > 0;
</script>

{#if showSection}
  <div class="rating">
    <section class="product-rating-review-section {hasPrice ? 'reserved-space' : ''}">
      {#if hasRating && productStore?.productTileRatingData}
        <ProductTileRatingReviews {isPLP} data={productStore.productTileRatingData} />
      {/if}

      <OnlineOnlyLabel dividerFlag={hasRating} showLabel={!!data?.isOnlineOnly} />
    </section>
  </div>
{/if}

<style lang="scss">
  .product-rating-review-section {
    display: flex;
  }
</style>
